<template>
    <div id="mentors-request" class="mentors-request">
        <template v-if="errorMessage">
            {{ errorMessage }}
        </template>
        <div class="container container--sm" ref="mentorRequestContainer">
            <onboarding-progress image-class="avatar mb-3"
                :image="avatar"
                :title="pageTitle"
                :description="pageSubtitle"
                :current="formStep.current"
                :steps="steps"
                :response-time="responseTime"
            />
            <mentor-request-form
                :form-step="formStep.current"
                :mentee-id="menteeId"
                :mentor-id="mentorId"
                :mentor-slug="mentorSlug"
                :mentor-request-id="mentorRequestId"
                :is-new-mentor-request="isNewMentorRequest"
                @loading-status-changed="isLoading = $event"
                :user-id="userId"
                :partner-id="partnerId"
            >
                <template #introduction-modal-title><slot name="introduction-modal-title"/></template>
                <template #introduction-modal-content><slot name="introduction-modal-content"/></template>
                <template #problem-modal-title><slot name="problem-modal-title"/></template>
                <template #problem-modal-content><slot name="problem-modal-content"/></template>
                <template #request-modal-title><slot name="request-modal-title"/></template>
                <template #request-modal-content><slot name="request-modal-content"/></template>
            </mentor-request-form>
        </div>
    </div>
</template>

<script>
import i18n from "src/i18n";
import OnboardingProgress from "src/views/onboarding/parts/onboarding-progress";
import MentorRequestForm from "src/views/forms/mentor-request-form";
import LoaderCluster from "src/views/loaders/loader-cluster";

export default {
    name: "MentorRequest",
    components: {
        MentorRequestForm,
        OnboardingProgress,
        LoaderCluster
    },
    props: [
        'mentorName',
        'menteeId',
        'mentorId',
        'mentorSlug',
        'avatar',
        'mentorRequestId',
        'isNewMentorRequest',
        'userId',
        'partnerId',
        'responseTime'
    ],
    data() {
        return {
            errorMessage: '',
            isLoading: true,
            mentor: {
                avatar: "",
                fullname: ""
            },
            formStep: {
                current: 1,
                total: 3
            }
        }
    },
    mounted() {
        this.$emitter.$on( 'change_form_step', (direction) => {
            if( direction === 'next' && this.formStep.current < this.formStep.total ) {
                this.formStep.current++;
            }
            if( direction === 'previous' && this.formStep.current > 1 ) {
                this.formStep.current--;
            }
        } )

        this.$watch('formStep.current', newValue => {
            // always scroll to the top of the form.
            let container = this.$refs.mentorRequestContainer;
            this.$nextTick(() => {
                // Bypass delay while html code is inserted into the DOM.
                setTimeout(() => {
                    container.scrollIntoView({behavior: 'smooth'});
                }, 100);
            });
        } )
    },
    computed: {
        pageTitle() {
            return i18n.global.t( 'mentor_request.page_title' ) + ' ' + this.mentorName;
        },
        pageSubtitle() {
            return i18n.global.t( 'mentor_request.page_subtitle' )
        },
        steps() {
            return [
                i18n.global.t( 'mentor_request.title_step_1' ),
                i18n.global.t( 'mentor_request.title_step_2' ),
                i18n.global.t( 'mentor_request.title_step_3' ),
            ]
        }
    }
}
</script>
